<div [ngClass]="styleClass">
    <div [ngStyle]="listStyle">
      <!-- <ng-scrollbar class="checklist-scrollbar"> -->
        <ul class="list-disp ps-2 pe-1 p-2">
          <li *ngFor="let item of filteredItems; let i = index" class="mb-2" [ngSwitch]="controlType">
            <div  *ngSwitchDefault style="display:inline-block; text-align:end;width:100%">
              <div style="float:left">
              <label class="custom-control-label" [attr.for]="assignDynamicId(filteredItems[i],i)">{{filteredItems[i].label}}</label>
              </div>
              <div style="text-align:end">
                <input type="text" maxlength="4" placeholder='{{placeholderin}}' [attr.value]="filteredItems[i].tagLimit" class="t-box custom-placeholder" style="text-align:end; width:8em !important" (change)="getChangeInput($event, filteredItems[i].name)"/>
              </div>
            </div>
          </li>
        </ul>
      <!-- </ng-scrollbar> -->
    </div>
  </div>